import { render } from "./ThePointsbar.vue?vue&type=template&id=084e5eda&scoped=true"
import script from "./ThePointsbar.vue?vue&type=script&lang=js"
export * from "./ThePointsbar.vue?vue&type=script&lang=js"

import "./ThePointsbar.vue?vue&type=style&index=0&id=084e5eda&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084e5eda"]])

export default __exports__